import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { title: 'Ana Sayfa', path: '/' },
    { title: 'Hakkında', path: '/hakkinda' },
    { title: 'Hizmetler', path: '/hizmetler' },
    { title: 'Kitaplar', path: '/kitaplar' },
    {
      title: 'Eğitimler',
      submenu: [
        { title: 'Kurumsal Eğitimler', path: '/kurumsal-egitimler' },
        { title: 'Bireysel Eğitimler', path: '/bireysel-egitimler' }
      ]
    },
    { title: 'Makaleler', path: '/makaleler' },
    { title: 'İletişim', path: '/iletisim' }
  ];

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg py-3' : 'bg-white/95 backdrop-blur-sm py-4'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://www.akarma.com.tr/upload/akarma/logo.png" 
              alt="akarma Logo" 
              className="h-12 md:h-14 w-auto object-contain"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-1 xl:space-x-2">
            {menuItems.map((item, index) => (
              <div key={index} className="relative group">
                {item.submenu ? (
                  <div
                    className="cursor-pointer px-3 py-2"
                    onMouseEnter={() => setActiveDropdown(item.title)}
                    onMouseLeave={() => setActiveDropdown(null)}
                  >
                    <button className="flex items-center space-x-1 text-gray-700 hover:text-akarma-blue transition-colors font-medium text-[15px]">
                      <span>{item.title}</span>
                      <ChevronDown size={16} />
                    </button>
                    {activeDropdown === item.title && (
                      <div className="absolute top-full left-0 mt-2 bg-white shadow-xl rounded-lg py-2 min-w-[220px] z-50 border border-gray-100">
                        {item.submenu.map((subItem, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subItem.path}
                            className="block px-4 py-2.5 text-gray-700 hover:bg-blue-50 hover:text-akarma-blue transition-colors text-[14px]"
                          >
                            {subItem.title}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    className={`px-3 py-2 text-gray-700 hover:text-akarma-blue transition-colors font-medium text-[15px] block ${
                      location.pathname === item.path ? 'text-akarma-blue' : ''
                    }`}
                  >
                    {item.title}
                  </Link>
                )}
              </div>
            ))}
          </div>

          {/* CTA Button */}
          <Link
            to="/iletisim"
            className="hidden lg:block px-6 py-2.5 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full hover:shadow-lg transition-all duration-300 font-medium"
          >
            İletişime Geç
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden text-gray-700 hover:text-akarma-blue transition-colors"
          >
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
            {menuItems.map((item, index) => (
              <div key={index} className="py-2">
                {item.submenu ? (
                  <div>
                    <div className="font-medium text-gray-700 px-4 py-2">{item.title}</div>
                    {item.submenu.map((subItem, subIndex) => (
                      <Link
                        key={subIndex}
                        to={subItem.path}
                        onClick={() => setIsOpen(false)}
                        className="block px-8 py-2 text-gray-600 hover:text-akarma-blue hover:bg-blue-50 transition-colors"
                      >
                        {subItem.title}
                      </Link>
                    ))}
                  </div>
                ) : (
                  <Link
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`block px-4 py-2 text-gray-700 hover:text-akarma-blue hover:bg-blue-50 transition-colors ${
                      location.pathname === item.path ? 'text-akarma-blue bg-blue-50' : ''
                    }`}
                  >
                    {item.title}
                  </Link>
                )}
              </div>
            ))}
            <Link
              to="/iletisim"
              onClick={() => setIsOpen(false)}
              className="block mx-4 mt-4 px-6 py-2.5 bg-gradient-to-r from-akarma-blue to-akarma-blue-700 text-white rounded-full text-center hover:shadow-lg transition-all duration-300 font-medium"
            >
              İletişime Geç
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;